export default __webpack_public_path__ + "static/media/languages.cdc06cb2.png";